import { render } from "./InstructorsLayout.vue?vue&type=template&id=5b71237f"
import script from "./InstructorsLayout.vue?vue&type=script&lang=js"
export * from "./InstructorsLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__